import { invitationDataSchema, } from '#types/sdk/data-objects';
export const INVITATION_ID_KEY = 'invitationId';
export const generateInvitationLink = (baseUrl, invitation) => {
    const invitationUrl = new URL(baseUrl);
    invitationUrl.searchParams.set(INVITATION_ID_KEY, invitation.id);
    invitationUrl.hash = invitation.linkSecret;
    return invitationUrl;
};
export const parseInvitationLink = (invitationUrl) => {
    if (Array.from(invitationUrl.searchParams).length != 1) {
        throw new InvalidInvitationLinkError(`Invalid invitation link: ${decodeUrl(invitationUrl)}`);
    }
    try {
        return createUnencryptedInvitationData(invitationUrl.searchParams.get(INVITATION_ID_KEY), 
        // the hash field of the URL includes the # symbol so we need to slice it
        invitationUrl.hash.slice(1));
    }
    catch (error) {
        throw new InvalidInvitationLinkError(`Invalid invitation link: ${decodeUrl(invitationUrl)}`);
    }
};
export const createUnencryptedInvitationData = (invitationId, linkSecret) => {
    return invitationDataSchema.parse({
        id: invitationId,
        linkSecret,
        isEncrypted: false,
    });
};
export class InvalidInvitationLinkError extends Error {
}
const decodeUrl = (url) => decodeURIComponent(url.toString());
